<template>
  <f7-page
    :theme-dark="dark"
    id="settings-lang">

    <f7-navbar
      back-link
      :theme-dark="dark"
      :title="t('settingsLangTitle')" />

    <f7-list>
      <f7-list-item
        v-for="(lang, i) in filteredLangs"
        :key="i"
        :title="lang.name"
        @click="select(lang)">
        <span
          v-if="lang.voice"
          slot="footer">
          {{ lang.voice }}
        </span>
        <FlagIcon
          rounded
          slot="media"
          :size="28"
          :code="lang.flag" />
        <span
          slot="after"
          v-if="selected(lang)">
          <FlatIcon
            v-if="lang.voice"
            :size="28"
            name="speaker" />
          <FlatIcon
            v-else
            :size="18"
            name="tick" />
        </span>
      </f7-list-item>
    </f7-list>

  </f7-page>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'SettingsLang',
  data () {
    return {
      filter: ''
    }
  },
  computed: {
    ...mapGetters({
      lang: 'global/lang',
      langs: 'global/langs',
      speechInstance: 'speech/speechInstance'
    }),
    filteredLangs () {
      return this.filter ? this.langs.filter(l => l.name.includes(this.filter)) : this.langs
    }
  },
  methods: {
    ...mapActions({
      setLang: 'global/setLang',
      setSetting: 'global/setSetting',
      setVoice: 'speech/setVoice'
    }),
    select (lang) {
      this.setSetting({ voice: lang.voice })
      this.setLang(lang.code)
      axios.defaults.headers.common['Accept-Language'] = lang.code

      this.setVoice(lang.voice)
      this.speechInstance.speak({
        text: lang.name
      })

      this.$f7router.navigate('/')
    },
    selected (lang) {
      return this.lang === lang.code
    }
  }
}
</script>

<docs>
```js
<SettingsLang />
```
</docs>
